import React from 'react'

function HomeComponet() {
  return (
    <div className='HomeComponent'>
      <div className='details'>
           <img src="https://d2908q01vomqb2.cloudfront.net/c5b76da3e608d34edb07244cd9b875ee86906328/2021/05/10/eCommerce.jpeg" alt="img"/>
      </div>
     </div>
  )
}

export default HomeComponet